import React from 'react';
import Camera from '../common/Icons/Camera';
import CameraDisabled from '../common/Icons/CameraDisabled';

export interface CameraButtonProps {
    disabled?: boolean;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CameraButton: React.FunctionComponent<CameraButtonProps> = ({
    disabled,
    className,
    onClick,
}) => {
    return (
        <button type="button" className={className} onClick={onClick} aria-label={disabled ? 'Turn Self View camera on' : 'Turn Self View camera off'} >
            {disabled ? <CameraDisabled className="icon" /> : <Camera className="icon" />}
        </button>
    );
};

export default CameraButton;
